import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useCollections from "../../../hooks/useCollections";
import ProfileContext from "../ProfileContext";
import useWorks from "../../../hooks/useWorks";
import { PAGE_STATE } from "../../../constants";

import { ReactComponent as LeftArrowSvg } from "../../../assets/icons/arrow-left.svg";
import AppContext from "../../../AppContext";
import ContentLoader from "react-content-loader";
import { useLocation } from "react-router-dom";

const View = ({ collectionId, onReturn }) => {
  const { user } = useContext(ProfileContext);
  const { viewProject } = useContext(AppContext);
  const { queryCollectionByUserId } = useCollections();
  const { queryWorks } = useWorks();
  const [works, setWorks] = useState(undefined);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [collection, setCollection] = useState(undefined);
  const location = useLocation();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const {
      data: [_collection],
    } = await queryCollectionByUserId(user._id, { _id: collectionId });

    // * Get works
    const { data: _works } = await queryWorks({
      _id: {
        $in: _collection.works,
      },
    });

    setCollection(_collection);
    setWorks(_works);
    setPageState(PAGE_STATE.IDLE);
  };

  if (pageState !== PAGE_STATE.IDLE || !works || !collection) {
    return (
      <div className="profile-collections-view">
        <div className="profile-collections-view-return" onClick={onReturn}>
          <LeftArrowSvg />
          <ContentLoader width={100} height={"25.5"}>
            <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-collections-view-list">
          <div className="profile-collections-view-list-item">
            <ContentLoader width={"100%"} height={"210"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
          <div className="profile-collections-view-list-item">
            <ContentLoader width={"100%"} height={"210"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
          <div className="profile-collections-view-list-item">
            <ContentLoader width={"100%"} height={"210"}>
              <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
            </ContentLoader>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-collections-view">
      <div className="profile-collections-view-return" onClick={onReturn}>
        <LeftArrowSvg />
        {collection.name}
      </div>
      <div className="profile-collections-view-list">
        {works.map(({ _id, banner }) => {
          return (
            <div
              key={_id}
              className="profile-collections-view-list-item"
              onClick={() => viewProject(_id, location)}
            >
              <img
                className="profile-collections-view-list-item__banner"
                alt="work-banner"
                src={banner}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

View.propTypes = {};

export default View;
